import { useQuery } from "@apollo/client";
import { Suspense } from "react";
import { useIntl } from "react-intl";

import Suspender from "lib/Suspender";

import { WorkspaceFinancialsDoc } from "operations";

import { LoadingSkeleton } from "@joor/design-system";
import { totalUnits } from "./ProductCount";
import { StyledContent, StyledLabel, StyledTitle } from "./styledComponents";

const useUnitCount = (workspaceId: string, isBrand: boolean) => {
  const { data, loading } = useQuery(WorkspaceFinancialsDoc, {
    variables: { workspaceId },
  });

  const mappedUnits = data?.retailWorkspace?.assortments?.flatMap((a) =>
    a.financialOverview.financialDetails
      ?.filter((c) =>
        isBrand ? c.isBrandCurrency === true : c.isBrandCurrency === false
      )
      .map((c) => ({ currency: c.currencyCode, unit: c.units.unitCount }))
  );
  const units = totalUnits(mappedUnits);

  return { loading, units };
};

export const UnitCount = ({
  workspaceId,
  moreCurrencies,
  isBrand,
}: {
  workspaceId: string;
  moreCurrencies: boolean;
  isBrand: boolean;
}) => {
  const intl = useIntl();
  const { loading, units } = useUnitCount(workspaceId, isBrand);

  const listUnitsCount = units?.map((count) => (
    <StyledTitle data-testid="unit-count-value">
      {intl.formatNumber(count) ?? 0}
    </StyledTitle>
  ));

  return (
    <StyledContent>
      <StyledLabel>Units</StyledLabel>
      <Suspense fallback={<LoadingSkeleton />}>
        <Suspender suspend={loading}>
          {moreCurrencies ? (
            listUnitsCount
          ) : (
            <StyledTitle data-testid="unit-count-value">
              {units[0] ? intl.formatNumber(units[0]) : 0}
            </StyledTitle>
          )}
        </Suspender>
      </Suspense>
    </StyledContent>
  );
};
